import React from 'react';
import classes from './TupleDivider.scss';

const tupleDivider = () => <div className={classes.Divider}></div>;

export default tupleDivider;


// WEBPACK FOOTER //
// ./src/components/Hotel/HotelTuple/TupleDivider/TupleDivider.js